<template>
  <nav class="navbar navbar-default navbar-fixed-top">
    <div class="container">
      <div class="navbar-header">
        <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar">
          <span class="sr-only">Navegação</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <router-link to="/" class="navbar-brand">{{ evento }}</router-link>
      </div>
      <div id="navbar" class="navbar-collapse collapse" aria-expanded="false" style="height: 1px;">
        <slot></slot>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  data () {
    return {
      evento: process.env.EVENTO
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Header.vue?d0cd3048